var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
export class AtenUsb {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: 'open',
                next: /open Command OK|Command Incorrect/i,
            },
        ];
        this.products = {
            '-LdjivRfDs-rpVBgRBT9': { name: 'CS1924M', prefix: 'i' },
            '-LdjjWd-v7kW88A8WOfE': { name: 'CS1922M', prefix: 'i' },
            '-Ldjk2j6ssn9tB5isl63': { name: 'US3344I', prefix: 'p' },
        };
        this.product = this.products['-LdjivRfDs-rpVBgRBT9'];
        // controls
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                // There is no query for determining the selected input on these products.
                return this.state.videoMatrixRoutes.values[key];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`sw ${this.product.prefix}${value.padStart(2, '0')}`, /^sw .(\d+) Command OK|Command OK|Command incorrect/i, tags);
                if (match[1])
                    return parseInt(match[1], 10).toString();
                return value;
            }),
        };
        // polling
        this.polls = [
            {
                intervalMs: 4000,
                function: () => __awaiter(this, void 0, void 0, function* () {
                    yield this.socket.send('open', /(open Command OK|Command Incorrect)/i, ['ping']);
                }),
            },
        ];
    }
    onConfigure(config) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.product = this.products[(_a = config.modelNumber) !== null && _a !== void 0 ? _a : '-LdjivRfDs-rpVBgRBT9'];
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
AtenUsb.driverType = 'socketDriver';
AtenUsb.key = '-LsCiehySCqbjfEnuknG';
AtenUsb.baseSocketOptions = {};
AtenUsb.socketOptions = [
    Object.assign(Object.assign({}, AtenUsb.baseSocketOptions), { port: 4999 }),
];
